.notification {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.notification--default {
  padding: 1rem;
}
.notification--bar {
  border: none;
  padding: 0.5rem 1rem;
}

.notification--neutral {
  background-color: var(--color-grey-300);
  border-left: 0.25rem solid var(--color-grey-600);
}
.notification--information {
  background-color: var(--color-navy-200);
  border-left: 0.25rem solid var(--color-navy-600);
}
.notification--success {
  background-color: var(--color-forest-200);
  border-left: 0.25rem solid var(--color-forest-600);
}
.notification--warning {
  background-color: var(--color-orange-200);
  border-left: 0.25rem solid var(--color-orange-600);
}
.notification--danger {
  background-color: var(--color-red-200);
  border-left: 0.25rem solid var(--color-red-600);
}

.notification--bar.notification--neutral {
  background-color: var(--color-grey-600);
  color: var(--color-uva-white);
}
.notification--bar.notification--information {
  background-color: var(--color-navy-600);
  color: var(--color-uva-white);
}
.notification--bar.notification--success {
  background-color: var(--color-forest-600);
}
.notification--bar.notification--warning {
  background-color: var(--color-orange-600);
}
.notification--bar.notification--danger {
  background-color: var(--color-red-600);
  color: var(--color-uva-white);
}

.notification-content {
  display: flex;
  gap: 1rem;
}
.notification-content--text {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.notification-title {
  font-weight: var(--semibold);
  margin: 0;
}
.notification-subtitle {
  margin: 0;
}

.notification-close-button {
  align-items: center;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: var(--color-uva-black);
  display: inline-flex;
  height: 1.5rem;
  justify-content: center;
  position: relative;
  transition: var(--transition-colors);
  width: 1.5rem;
}

.notification-close-button:focus-visible {
  outline: 0.125rem dotted var(--color-navy-600);
  outline-offset: 0.125rem;
}

.notification-close-button:hover {
  cursor: pointer;
  outline: 0;
}

/* make the clickable area of the overlay close button 42x42px simmilar to a regular button */
.notification-close-button::after {
  bottom: -0.625rem;
  content: "";
  left: -0.625rem;
  position: absolute;
  right: -0.625rem;
  top: -0.625rem;
}

.notification-close-button--bar--neutral,
.notification-close-button--bar--information,
.notification-close-button--bar--danger {
  color: var(--color-uva-white);
}

.notification-close-button--neutral:hover {
  background-color: var(--color-grey-600);
  color: var(--color-uva-white);
}
.notification-close-button--information:hover {
  background-color: var(--color-navy-600);
  color: var(--color-uva-white);
}
.notification-close-button--success:hover {
  background-color: var(--color-forest-600);
}
.notification-close-button--warning:hover {
  background-color: var(--color-orange-600);
}
.notification-close-button--danger:hover {
  background-color: var(--color-red-600);
  color: var(--color-uva-white);
}

.notification-close-button--bar--neutral:hover {
  background-color: var(--color-grey-300);
  color: var(--color-uva-black);
}
.notification-close-button--bar--information:hover {
  background-color: var(--color-navy-300);
  color: var(--color-uva-black);
}
.notification-close-button--bar--success:hover {
  background-color: var(--color-forest-300);
}
.notification-close-button--bar--warning:hover {
  background-color: var(--color-orange-300);
}
.notification-close-button--bar--danger:hover {
  background-color: var(--color-red-300);
  color: var(--color-uva-black);
}
